import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
@Component({
  selector: 'entity-status',
  template: `
    @if (
      {
        row: columnData | async,
      };
      as $
    ) {
      @if ($.row?.status?.toLowerCase() === 'scheduled') {
        <p-tag
          styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
          severity="info"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
      @if ($.row?.status?.toLowerCase() === 'applied') {
        <p-tag
          styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap"
          severity="success"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
      @if ($.row?.status?.toLowerCase() === 'skipped') {
        <p-tag
          severity="warning"
          styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
      @if ($.row?.status?.toLowerCase() === 'cancelled') {
        <p-tag
          severity="danger"
          styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
      @if ($.row?.status?.toLowerCase() === 'failed') {
        <p-tag
          styleClass="text-xxs bg-indigo-600 uppercase white-space-nowrap"
          severity="danger"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
      @if ($.row?.status?.toLowerCase() === 'queued') {
        <p-tag
          styleClass="text-xxs bg-indigo-600 uppercase white-space-nowrap"
          severity="danger"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
      @if ($.row?.status?.toLowerCase() === 'inprogress') {
        <p-tag
          styleClass="text-xxs bg-indigo-600 uppercase white-space-nowrap"
          severity="danger"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
      @if ($.row?.status?.toLowerCase() === 'completed') {
        <p-tag
          styleClass="text-xxs bg-indigo-600 uppercase white-space-nowrap"
          severity="danger"
          >{{ $.row.status | titlecase }}
        </p-tag>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe, TitleCasePipe],
})
export class PlanChangeStatusComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
}
